<template>
  <article class="legal">
    <header>
      <a href="/pila"><img src="/pila/logo.png" alt="Pila"></a>
      <p>Documento público do Pila. Atualizado em 18 de outubro de 2026.</p>
      <h1>{{ current.title }}</h1>
    </header>
    <section v-for="section in current.sections" :key="section.heading">
      <h2>{{ section.heading }}</h2>
      <p v-for="(paragraph, index) in section.paragraphs" :key="index">{{ paragraph }}</p>
    </section>
    <footer>
      <a href="/pila">Voltar ao Pila</a>
      <button type="button" @click="other = true">{{ kind === 'privacy' ? 'Termos de uso' : 'Política de privacidade' }}</button>
    </footer>
    <div v-if="other" class="sheet" @click.self="other = false">
      <div class="sheet-card" role="dialog" aria-modal="true">
        <button type="button" class="sheet-close" @click="other = false">Fechar</button>
        <h2>{{ otherDoc.title }}</h2>
        <section v-for="section in otherDoc.sections" :key="section.heading">
          <h3>{{ section.heading }}</h3>
          <p v-for="(paragraph, index) in section.paragraphs" :key="index">{{ paragraph }}</p>
        </section>
      </div>
    </div>
  </article>
</template>

<script>
import { privacy, terms } from '@/data/pilaDocuments'
import { applyPilaHead } from '@/utils/pilaHead'

export default {
  name: 'PilaLegal',
  data() {
    return { other: false }
  },
  computed: {
    kind() {
      return this.$route.meta.document === 'terms' ? 'terms' : 'privacy'
    },
    current() {
      return this.kind === 'terms' ? terms : privacy
    },
    otherDoc() {
      return this.kind === 'terms' ? privacy : terms
    },
  },
  watch: {
    kind() {
      this.other = false
      this.publish()
    },
  },
  mounted() {
    this.publish()
  },
  methods: {
    publish() {
      window.scrollTo(0, 0)
      applyPilaHead({
        title: `${this.current.title} — Pila`,
        description: this.current.description,
        url: `https://fontes.business/pila/${this.kind === 'terms' ? 'termos' : 'privacidade'}`,
      })
    },
  },
}
</script>

<style scoped>
.legal {
  max-width: 760px;
  margin: 0 auto;
  padding: 48px 22px 72px;
  color: #1c2416;
  font-family: Georgia, serif;
}

.legal header img { height: 56px; width: auto; }

.legal h1, .legal h2 { font-family: Georgia, serif; color: #1c2416; }

.legal h1 { font-size: 40px; margin: 18px 0; }

.legal h2 { font-size: 22px; margin: 28px 0 8px; }

.legal p { font-size: 18px; line-height: 1.6; }

.legal footer { display: flex; gap: 18px; margin-top: 36px; }

.legal a, .legal button { color: #0f6e56; font-weight: 700; background: none; border: 0; padding: 0; cursor: pointer; font: inherit; }
.sheet { position: fixed; inset: 0; z-index: 20; display: grid; place-items: center; padding: 24px; background: rgba(28, 36, 22, 0.46); }
.sheet-card { width: min(720px, 100%); max-height: min(78vh, 720px); overflow: auto; padding: 28px; border-radius: 24px; background: #fffdf8; }
.sheet-close { margin-bottom: 12px; }
</style>
